// mantine
import { Collapse } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// components
import { PopoverButton } from '@newo/ui-kit';
import { Plus } from 'lucide-react';
import { IRunnerType, TSkill, TSkillData } from '@newo/api/gateway';
import AddSkillForm from '@/modules/Designer/components/Skills/components/AddSkillForm';
import SkillItem from '@/modules/Designer/components/Skills/components/SkillItem';
import SectionHeading from '@/components/SectionHeading';
import NoRecords from '@/components/NoRecords';
// icons
// utils
import { hints } from '@/modules/Designer/Designer.data';

interface SkillsProps {
    className?: string;
    items: TSkill[];
    selectedSkillId?: string;
    defaultRunnerType?: IRunnerType;
    onSelect: (skillId: string) => void;
    onCreate: (data: TSkillData) => Promise<{ id: string }>;
    onDelete: (skill: TSkill) => void;
}

const Skills = ({
    className,
    items,
    selectedSkillId,
    defaultRunnerType,
    onSelect,
    onCreate,
    onDelete
}: SkillsProps) => {
    const [isOpened, { toggle }] = useDisclosure(true);
    const handleSubmit = async (data: TSkillData) => {
        return onCreate(data);
    };

    const handleSelect = (skillId: string) => {
        onSelect(skillId);
    };

    return (
        <div className={className}>
            <div className="flex flex-nowrap items-center pr-3">
                <SectionHeading
                    hint={hints.skills}
                    isOpened={isOpened}
                    title="Skills"
                    onClick={toggle}
                />
                <PopoverButton title="Add Skill" trigger={<Plus />}>
                    {(close) => (
                        <AddSkillForm
                            defaultRunnerType={defaultRunnerType}
                            onCancel={close}
                            onSubmit={handleSubmit}
                        />
                    )}
                </PopoverButton>
            </div>
            <Collapse in={isOpened}>
                {items.length === 0 ? <NoRecords /> : undefined}
                {items.map((skill) => (
                    <SkillItem
                        isSelected={selectedSkillId === skill.id}
                        key={skill.id}
                        skill={skill}
                        onDelete={onDelete}
                        onSelect={handleSelect}
                        onUpdate={handleSubmit}
                    />
                ))}
            </Collapse>
        </div>
    );
};

export default Skills;
